import DateFnsUtils from '@date-io/date-fns';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import AddIcon from '@material-ui/icons/Add';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import DeleteIcon from '@material-ui/icons/Delete';
import PublishIcon from '@material-ui/icons/Publish';
import MuiAlert from '@material-ui/lab/Alert';
// import { KeyboardDatePicker } from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'date-fns';
import * as React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ClientTypeService, OrganizationTypeService } from '../../remote-api/api/master-services';
import { Button } from '@material-ui/core';
import Asterisk from '../../shared-components/components/red-asterisk';

const organizationservice = new OrganizationTypeService();
const clienttypeervice = new ClientTypeService();

let org$ = organizationservice.getOrganizationTypes();
let ct$ = clienttypeervice.getCleintTypes();

const useStyles = makeStyles(theme => ({
  input1: {
    width: '50%',
  },
  clientTypeRadioGroup: {
    flexWrap: 'nowrap',
    '& label': {
      flexDirection: 'row',
    },
  },
  formControl: {
    minWidth: '90%',
  },
}));

function useQuery1() {
  return new URLSearchParams(useLocation().search);
}

export default function BasicDetailsStepComponent(props) {
  const classes = useStyles();
  const query = useQuery1();

  console.log(props);

  const { clientDetail } = props;
  const [organizationTypes, setOrganizationTypes] = React.useState([]);
  const [clientTypes, setClientTypes] = React.useState([]);
  const [groupTypes, setGroupTypes] = React.useState([]);
  const [prefixes, setPrefixes] = React.useState([]);
  const [suffixes, setSuffixes] = React.useState([]);
  const [openRequired, setOpenRequired] = React.useState(false);
  const [idErrorMsg, setIdErrorMsg] = React.useState(false);
  const [checkContact, setCheckContact] = React.useState(false);
  const [panCheck, setPanCheck] = React.useState(false);
  const [checkDuplicateContact, setCheckDuplicateContact] = React.useState(false);

  const [contactList, setContactList] = React.useState([{ altEmail: '', altContact: '' }]);
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [selectedImgLink, setSelectedImgLink] = React.useState('');
  const [identificationList, setIdentificationList] = React.useState([
    {
      identificationType: '',
      identificationNo: '',
      docFormat: 'image/jpeg',
      document: props.imgF,
    },
  ]);
  const [identificationTypes, setIdentificationTypes] = React.useState([]);
  const [parentClients, setParentClients] = React.useState([]);

  const useObservable = (observable, setter, type = '') => {
    useEffect(() => {
      let subscription = observable.subscribe(result => {
        if (type === 'clientType') {
          const clType = result.content.filter(ct => ct.name === clientDetail.clientTypeName);
          if (clType.length > 0) {
            setClientDetail({
              ...clientDetail,
              clientTypeCd: clType[0].code,
            });
          }
        }
        setter(result.content);
      });
      return () => subscription.unsubscribe();
    }, [observable, setter]);
  };
  useObservable(org$, setOrganizationTypes);
  useObservable(ct$, setClientTypes, 'clientType');

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  function validateEmail(email) {
    const re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    return re.test(String(email).toLowerCase());
  }

  useEffect(() => {
    setPrefixes(props.prefixes);
  }, [props.prefixes]);
  useEffect(() => {
    setSuffixes(props.suffixes);
  }, [props.suffixes]);
  useEffect(() => {
    setIdentificationTypes(props.identificationTypes);
  }, [props.identificationTypes]);
  useEffect(() => {
    setContactList(props.contactList);
  }, [props.contactList]);
  useEffect(() => {
    setIdentificationList(props.identificationList);
  }, [props.identificationList]);
  useEffect(() => {
    setSelectedDate(props.selectedDate);
  }, [props.selectedDate]);
  useEffect(() => {
    setSelectedImgLink(props.selectedImgLink);
  }, [props.selectedImgLink]);
  useEffect(() => {
    setGroupTypes(props.groupTypes);
  }, [props.groupTypes]);
  useEffect(() => {
    setParentClients(props.parentClients);
  }, [props.parentClients]);

  useEffect(() => {
    if (!props.clientDetail.clientTypeName) {
      const clientTypeDetails = clientTypes.filter(ct => ct.code == clientDetail.clientTypeCd);
      if (clientTypeDetails.length > 0) {
        setClientDetail({
          ...clientDetail,
          clientTypeName: clientTypeDetails[0].name,
        });
      }
    }
  }, [props.clientDetail]);

  const setName = (value, pos = '') => {
    if (!pos) return value;
    if (pos === 'a') {
      return value ? value + ' ' : '';
    } else {
      return value ? ' ' + value : '';
    }
  };

  const handleChange = event => {
    const { name, value } = event.target;
    console.log('nanananananannanaanannnna', name);
    console.log('nanananananannanaanannnnavavavavavavavavaavavavav', value);

    let dname = {};
    if (clientDetail.clientTypeName !== 'Group') {
      if (name === 'firstName') {
        dname = {
          displayName: setName(value) + setName(clientDetail.middleName, 'b') + setName(clientDetail.lastName, 'b'),
        };
      } else if (name === 'middleName') {
        dname = {
          displayName: setName(clientDetail.firstName, 'a') + setName(value) + setName(clientDetail.lastName, 'b'),
        };
      } else if (name === 'lastName') {
        dname = {
          displayName: setName(clientDetail.firstName, 'a') + setName(clientDetail.middleName, 'a') + setName(value),
        };
      }
    } else if (name === 'firstName') {
      dname = { displayName: value };
    }

    // console.log(value)
    let clientTypeName = '';
    if (name === 'clientTypeCd') {
      const clType = clientTypes.filter(ct => ct.code === value);
      if (clType.length > 0) {
        clientTypeName = clType[0].name;
      }
    }

    if (name === 'panNumber') {
      setClientDetail({
        ...clientDetail,
        [name]: value.toUpperCase(),
        ...(name === 'clientTypeCd' && { clientTypeName }),
        ...dname,
      });
    } else if (name !== 'panNumber') {
      setClientDetail({
        ...clientDetail,
        [name]: value,
        ...(name === 'clientTypeCd' && { clientTypeName }),
        ...dname,
      });
    }
  };

  const handleSubmit = event => {
    if (clientDetail.email) {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(clientDetail.email)) {
        setCheckContact(true);
        return;
      }
    }

    if (
      clientDetail.firstName == '' ||
      clientDetail.displayName == '' ||
      clientDetail.panNumber == '' ||
      clientDetail.contact == '' ||
      clientDetail.firstName == null ||
      clientDetail.clientTypeCd == '' ||
      clientDetail.clientTypeCd == null ||
      clientDetail.displayName == null ||
      clientDetail.panNumber == null ||
      clientDetail.contact == null
    ) {
      setOpenRequired(true);
      return;
    }

    if (!/^[a-zA-Z0-9]+$/i.test(clientDetail.panNumber)) {
      setPanCheck(true);
      return;
    }

    if (identificationList.length === 1) {
      if (identificationList[0].identificationType !== '' && identificationList[0].identificationNo === '') {
        setIdErrorMsg(true);
        return;
      }
      if (identificationList[0].identificationType === '' && identificationList[0].identificationNo !== '') {
        setIdErrorMsg(true);
        return;
      }
    }
    if (identificationList.length > 1) {
      identificationList.forEach(val => {
        if (val.identificationType === '' || val.identificationNo === '') {
          setIdErrorMsg(true);
          return;
        }
      });
    }
    if (clientDetail.contact.length !== 10) {
      setCheckContact(true);
      return;
    }

    /** Duplicate Contact no & Emial Check */
    const duplicateContactList = contactList.filter(ctList => {
      return ctList.altContact === clientDetail.contact || (clientDetail.email && ctList.altEmail === clientDetail.email);
    });
    if (duplicateContactList.length > 0) {
      setCheckDuplicateContact(true);
      return;
    }

    /** Alternate Contact & email validation */
    for (let i = 0; i < contactList.length; i++) {
      const v = contactList[i];
      if (v.altContact && v.altContact.length !== 10) {
        setCheckContact(true);
        return;
      } else if (v.altEmail && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(v.altEmail)) {
        setCheckContact(true);
        return;
      }
    }

    // if (clientDetail.contact.email !== '' && validateEmail(clientDetail.contact.email) === false) {
    //     setCheckContact(true);
    //     return;
    // }
    // contactList.forEach(cnt => {
    //     if (cnt.altContact.length !== 0) {
    //         setCheckContact(true);
    //         return;
    //     }
    //     if (validateEmail(cnt.altEmail) === false) {
    //         setCheckContact(true);
    //         return;
    //     }

    // })

    let contacts = [];
    let emailsLists = [];

    contacts.push({ contactNo: clientDetail.contact, contactType: 'PRIMARY' });
    emailsLists.push({ emailId: clientDetail.email, contactType: 'PRIMARY' });
    contactList.forEach(cnt => {
      contacts.push({ contactNo: cnt.altContact, contactType: 'ALTERNATE' });
      emailsLists.push({ emailId: cnt.altEmail, contactType: 'ALTERNATE' });
    });

    let payloadOne = {
      clientBasicDetails: {
        // prefixCd: clientDetail.prefixCd,
        // middleName: clientDetail.middleName,
        // lastName: clientDetail.lastName,
        // suffixCd: clientDetail.suffixCd,
        firstName: clientDetail.firstName,
        displayName: clientDetail.displayName,
        clientTypeCd: clientDetail.clientTypeCd,
        orgTypeCd: clientDetail.orgTypeCd,
        partnerNumber: clientDetail.partnerNumber,
        combinationPartnerId: clientDetail.combinationPartnerId,
        gstNo: clientDetail.gstNo,
        panNumber: clientDetail.panNumber,
        incorporationNumber: clientDetail.incorporationNumber,
        dataOfIncorporation: new Date(selectedDate).getTime(),
        countryOfIncorporation: clientDetail.countryOfIncorporation,
        policeStation: clientDetail.policeStation,
        logoFormat: clientDetail.logoFormat,
        websiteUrl: clientDetail.websiteUrl,
        prospectId: clientDetail.prospectId ? clientDetail.prospectId : null,
        logo: clientDetail.logo || props.imgF,
        contactNos: contacts,
        emails: emailsLists,
      },
    };

    if (
      identificationList.length === 1 &&
      identificationList[0].identificationType !== '' &&
      identificationList[0].identificationNo !== ''
    ) {
      payloadOne['clientBasicDetails']['identifications'] = identificationList;
    }

    if (identificationList.length > 1) {
      payloadOne['clientBasicDetails']['identifications'] = identificationList;
    }

    if (clientDetail.clientTypeName === 'Group') {
      if (clientDetail.groupTypeCd === '') {
        setOpenRequired(true);
        return;
      }
      payloadOne['clientBasicDetails']['groupTypeCd'] = clientDetail.groupTypeCd;
    }
    if (clientDetail.clientTypeName === 'Retail') {
      if (clientDetail.lastName === '') {
        setOpenRequired(true);
        return;
      }
      payloadOne['clientBasicDetails']['prefixCd'] = clientDetail.prefixCd;
      payloadOne['clientBasicDetails']['suffixCd'] = clientDetail.suffixCd;
      payloadOne['clientBasicDetails']['middleName'] = clientDetail.middleName;
      payloadOne['clientBasicDetails']['lastName'] = clientDetail.lastName;
    }

    if (clientDetail.orgTypeCd === 'OT117246') {
      if (clientDetail.parentclientId === '') {
        setOpenRequired(true);
        return;
      }
      payloadOne['clientBasicDetails']['parentclientId'] = clientDetail.parentclientId;
    }

    if (query.get('mode') === 'edit') {
      payloadOne['clientBasicDetails']['code'] = clientDetail.code;
    }
    props.handleSubmitStepOne(payloadOne);
  };

  //Contact list functions
  const handleInputChangeContact = (e, index) => {
    const { name, value } = e.target;
    const list = [...contactList];
    list[index][name] = value;
    setContactList(list);
  };

  const handleAddClickContact = () => {
    setContactList([...contactList, { altEmail: '', altContact: '' }]);
  };
  const handleRemoveClickContact = index => {
    const list = [...contactList];
    list.splice(index, 1);
    setContactList(list);
  };

  const handleDateChange = date => {
    setSelectedDate(date);
    props.setSelectedDate(date);
    const timestamp = new Date(date).getTime();
    setClientDetail({
      ...clientDetail,
      dataOfIncorporation: new Date(date).getTime(),
    });
  };

  const handleImgChange = e => {
    let base64String = '';
    const file = e.target['files'][0];

    const reader = new FileReader();

    reader.onload = function() {
      base64String = reader.result.replace('data:', '').replace(/^.+,/, '');

      setSelectedImgLink(reader.result);
      setClientDetail({
        ...clientDetail,
        logo: base64String,
      });
      props.setUploadSuccess(true);
    };
    reader.readAsDataURL(file);
  };

  const handleImgChange1 = (e, index) => {
    let base64String = '';
    const file = e.target['files'][0];

    const reader = new FileReader();

    reader.onload = function() {
      base64String = reader.result.replace('data:', '').replace(/^.+,/, '');

      // imageBase64Stringsep = base64String;

      // alert(imageBase64Stringsep);
      const list = [...identificationList];
      list[index]['document'] = base64String;
      list[index]['docFormat'] = file.type;
      setIdentificationList(list);
    };
    reader.readAsDataURL(file);
    props.setUploadSuccess(true);
  };

  //Indentification Type
  const handleInputChangeIndentification = (e, index) => {
    const { name, value } = e.target;
    const list = [...identificationList];
    list[index][name] = value;
    setIdentificationList(list);
  };

  const handleRemoveClickIndentification = index => {
    const list = [...identificationList];
    list.splice(index, 1);
    setIdentificationList(list);
  };

  const handleAddClickIndentification = () => {
    setIdentificationList([...identificationList, { identificationType: '', identificationNo: '' }]);
  };

  const setClientDetail = e => {
    props.setClientDetail(e);
  };

  const handleClose = e => {
    props.handleClose(e);
  };

  const handlePChange = (e, value) => {
    setClientDetail({
      ...clientDetail,
      pOrgData: value,
      parentclientId: value.id,
    });
  };

  const validatePanNumber = panNumber => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panRegex.test(panNumber);
  };

  const handleSnackClose = (event, reason) => {
    setOpenRequired(false);
  };
  const handleIDErrorClose = (event, reason) => {
    setIdErrorMsg(false);
  };
  const handleContactCheckClose = (event, reason) => {
    setCheckContact(false);
  };
  const handlePANCheckClose = (event, reason) => {
    setPanCheck(false);
  };
  const handleDuplicateContactCheckClose = (event, reason) => {
    setCheckDuplicateContact(false);
  };

  console.log(clientDetail);
  console.log(clientTypes);

  return (
    <Paper elevation="none">
      <Box p={3} my={2}>
        <Snackbar open={panCheck} autoHideDuration={3000} onClose={handlePANCheckClose}>
          <Alert onClose={handlePANCheckClose} severity="error">
            Please enter a valid PAN number (only alphanumeric allowed)
          </Alert>
        </Snackbar>
        <Snackbar open={openRequired} autoHideDuration={3000} onClose={handleSnackClose}>
          <Alert onClose={handleSnackClose} severity="error">
            Please fill up all required fields marked with *
          </Alert>
        </Snackbar>
        <Snackbar open={checkContact} autoHideDuration={6000} onClose={handleContactCheckClose}>
          <Alert onClose={handleContactCheckClose} severity="error">
            Please enter valid Contact number/Email id
          </Alert>
        </Snackbar>
        <Snackbar open={checkDuplicateContact} autoHideDuration={6000} onClose={handleDuplicateContactCheckClose}>
          <Alert onClose={handleDuplicateContactCheckClose} severity="error">
            Alternate contact/Email cant be same with the priamry contact/email
          </Alert>
        </Snackbar>
        <Snackbar open={idErrorMsg} autoHideDuration={6000} onClose={handleIDErrorClose}>
          <Alert onClose={handleIDErrorClose} severity="error">
            Please provide both Identification Type and Identification Number.
          </Alert>
        </Snackbar>
        {/* <form onSubmit={handleSubmit}> */}
        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Client type*</FormLabel>
              <RadioGroup
                aria-label="clientTypeCd"
                name="clientTypeCd"
                // value={clientDetail.clientTypeCd?.toUpperCase()}
                // value={clientDetail.clientTypeCd?.toUpperCase() || ''}
                value={clientDetail.clientTypeCd || ''}
                onChange={handleChange}
                row
                className={classes.clientTypeRadioGroup}>
                {clientTypes.map(ele => {
                  return <FormControlLabel value={ele.code} key={ele.code} control={<Radio />} label={ele.name} />;
                })}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          {clientDetail.clientTypeName === 'Group' && (
            <div style={{ display: 'flex', gap: 70 }}>
              <Grid item xs={12} sm={6} md={4} style={{ marginBottom: '20px' }}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label" style={{ marginBottom: '10px' }}>
                    Group Type <Asterisk />
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    name="groupTypeCd"
                    id="demo-simple-select"
                    value={clientDetail.groupTypeCd}
                    style={{ width: 200 }}
                    onChange={handleChange}>
                    {groupTypes.map(ele => {
                      return <MenuItem value={ele.code}>{ele.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label" style={{ marginBottom: '10px' }}>
                    Organization type <Asterisk />
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="orgTypeCd"
                    value={clientDetail.orgTypeCd}
                    style={{ width: 200 }}
                    onChange={handleChange}>
                    {organizationTypes.map(ele => {
                      return <MenuItem value={ele.code}>{ele.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </div>
          )}
          {clientDetail.clientTypeName === 'Group' && clientDetail.orgTypeCd === 'OT117246' ? (
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                id="combo-box-demo"
                options={parentClients}
                getOptionLabel={option => option.name}
                value={clientDetail.pOrgData}
                style={{ width: '50%' }}
                renderInput={params => <TextField {...params} label="Parent Organization*" />}
                name="parentclientId"
                onChange={handlePChange}
              />
            </Grid>
          ) : (
            <div />
          )}
        </Grid>
        <Grid container spacing={3} style={{ marginBottom: '20px' }} />

        <Box pb={3}>
          <Divider />
        </Box>

        {clientDetail.clientTypeName === 'Group' ? (
          <Grid container spacing={3} style={{ marginBottom: '20px' }}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className={classes.formControl}>
                <TextField
                  size="small"
                  id="standard-basic"
                  name="firstName"
                  value={clientDetail.firstName}
                  onChange={handleChange}
                  label={
                    <span>
                      Name <Asterisk />
                    </span>
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="standard-basic"
                  name="displayName"
                  value={clientDetail.displayName}
                  onChange={handleChange}
                  label={
                    <span>
                      Display Name <Asterisk />
                    </span>
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : (
          <div>
            <Grid container spacing={3} style={{ marginBottom: '20px' }}>
              <Grid item xs={12} sm={6} md="auto">
                <FormControl style={{ minWidth: 'content' }}>
                  <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                    Prefix
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    name="prefixCd"
                    value={clientDetail.prefixCd}
                    style={{ width: 100 }}
                    onChange={handleChange}>
                    {prefixes.map(ele => {
                      return <MenuItem value={ele.code}>{ele.abbreviation}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="firstName"
                    label={
                      <span>
                        First Name <Asterisk />
                      </span>
                    }
                    value={clientDetail.firstName}
                    onChange={handleChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="middleName"
                    value={clientDetail.middleName}
                    onChange={handleChange}
                    label="Middle Name"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="lastName"
                    value={clientDetail.lastName}
                    onChange={handleChange}
                    label={
                      <span>
                        Last Name <Asterisk />
                      </span>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={3} style={{ marginBottom: '20px' }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                    Suffix
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    name="suffixCd"
                    value={clientDetail.suffixCd}
                    onChange={handleChange}>
                    {suffixes.map(ele => {
                      return <MenuItem value={ele.id}>{ele.abbreviation}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="displayName"
                    value={clientDetail.displayName}
                    onChange={handleChange}
                    label={
                      <span>
                        Display Name <Asterisk />
                      </span>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        )}
        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                type="text"
                onKeyPress={event => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                name="contact"
                value={clientDetail.contact}
                onChange={handleChange}
                label={
                  <span>
                    Contact No <Asterisk />
                  </span>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="email"
                value={clientDetail.email}
                onChange={handleChange}
                label="Email id"
              />
            </FormControl>
          </Grid>
          {query.get('mode') === 'edit' ? (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="standard-basic"
                  name="code"
                  value={clientDetail.code}
                  onChange={handleChange}
                  label="Client Code"
                  disabled
                />
              </FormControl>
            </Grid>
          ) : null}
        </Grid>
        {contactList.map((x, i) => {
          return (
            <Grid container spacing={3} style={{ marginBottom: '20px' }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    type="text"
                    onKeyPress={event => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    name="altContact"
                    value={x.altContact}
                    onChange={e => handleInputChangeContact(e, i)}
                    label="Alt. Contact No"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="altEmail"
                    value={x.altEmail}
                    onChange={e => handleInputChangeContact(e, i)}
                    label="Alt. Email id"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', alignItems: 'center' }}>
                {contactList.length !== 1 && (
                  <Button
                    className="mr10 p-button-danger"
                    onClick={() => handleRemoveClickContact(i)}
                    variant="contained"
                    color="secondary"
                    style={{ marginRight: '5px' }}>
                    <DeleteIcon />
                  </Button>
                )}
                {contactList.length - 1 === i && (
                  <Button variant="contained" color="primary" onClick={handleAddClickContact}>
                    <AddIcon />
                  </Button>
                )}
              </Grid>
            </Grid>
          );
        })}

        <Box pb={3}>
          <Divider />
        </Box>

        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="incorporationNumber"
                value={clientDetail.incorporationNumber}
                onChange={handleChange}
                label="Incorporation No"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {/* <Grid container justify="space-around"> */}
                <KeyboardDatePicker
                  views={['year', 'month', 'date']}
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  autoOk={true}
                  label="Date Of Incorporation"
                  maxDate={new Date()}
                  value={selectedDate}
                  onChange={handleDateChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                style={{ minWidth: 240 }}
                id="standard-basic"
                name="countryOfIncorporation"
                onInput={e => {
                  e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '');
                }}
                value={clientDetail.countryOfIncorporation}
                onChange={handleChange}
                label="Country of Incorporation"
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="policeStation"
                value={clientDetail.policeStation}
                onChange={handleChange}
                label="Police Station"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="websiteUrl"
                value={clientDetail.websiteUrl}
                onChange={handleChange}
                label="Website URL"
              />
            </FormControl>
          </Grid>
          <Grid item xs={1}>
            <span>Profile Picture</span>
            <div
              style={{
                border: '1px solid',
                marginBottom: '8px',
                alignItems: 'center',
                height: '105px',
                width: '105px',
                display: 'flex',
                justifyContent: 'center',
              }}>
              <img src={selectedImgLink} style={{ height: '100px', width: '100px' }} />
            </div>
            <input
              accept="image/*"
              className={classes.input1}
              id="contained-button-file"
              single
              type="file"
              onChange={handleImgChange}
              style={{ display: 'none' }}
            />
            <label htmlFor="contained-button-file">
              <Button variant="contained" color="primary" component="span">
                <AddAPhotoIcon />
              </Button>
            </label>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="partnerNumber"
                value={clientDetail.partnerNumber}
                onChange={handleChange}
                label="Partner No"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                style={{ minWidth: 220 }}
                id="standard-basic"
                name="combinationPartnerId"
                value={clientDetail.combinationPartnerId}
                onChange={handleChange}
                label="Combination Partner No."
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="panNumber"
                value={clientDetail.panNumber}
                error={clientDetail.panNumber.length > 9 && !validatePanNumber(clientDetail.panNumber)}
                helperText={
                  clientDetail.panNumber.length > 9 && !validatePanNumber(clientDetail.panNumber) ? 'Invalid PAN number' : ''
                }
                onChange={handleChange}
                label={
                  <span>
                    PAN No. <Asterisk />
                  </span>
                }
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="gstNo"
                value={clientDetail.gstNo}
                onChange={handleChange}
                label="GST No."
              />
            </FormControl>
          </Grid>
        </Grid>

        {identificationList.map((x, i) => {
          return (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                    Identification Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="identificationType"
                    value={x.identificationType}
                    onChange={e => handleInputChangeIndentification(e, i)}>
                    {identificationTypes.map(ele => {
                      return <MenuItem value={ele.code}>{ele.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3} container alignItems="flex-end">
                <FormControl style={{ flex: 1 }} className="mr-2">
                  <TextField
                    id="standard-basic"
                    name="identificationNo"
                    value={x.identificationNo}
                    onChange={e => handleInputChangeIndentification(e, i)}
                    label="Identification No"
                  />
                </FormControl>
                {/* </Grid>
              <Grid item xs={1} style={{ display: 'flex', alignItems: 'center' }}> */}
                <input
                  accept="image/*"
                  className={classes.input}
                  id={'contained-button-file' + i.toString()}
                  single
                  name="document"
                  type="file"
                  onChange={e => handleImgChange1(e, i)}
                  style={{ display: 'none' }}
                />
                <label htmlFor={'contained-button-file' + i.toString()} style={{ marginBottom: 0 }}>
                  <Button variant="contained" color="primary" component="span">
                    <PublishIcon />
                  </Button>
                </label>

                {/* </label> */}
              </Grid>

              <Grid item xs={12} sm={12} md={3} container alignItems="flex-end">
                {identificationList.length !== 1 && (
                  <Button
                    className="mr10 p-button-danger"
                    onClick={() => handleRemoveClickIndentification(i)}
                    variant="contained"
                    color="secondary"
                    style={{ marginLeft: '5px' }}>
                    <DeleteIcon />
                  </Button>
                )}
                {identificationList.length - 1 === i && (
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: '5px' }}
                    onClick={handleAddClickIndentification}>
                    <AddIcon />
                  </Button>
                )}
              </Grid>
            </Grid>
          );
        })}
        <Grid container spacing={3} className="p-2">
          <Grid item xs={12} container justifyContent="flex-end">
            <Button variant="contained" color="primary" style={{ marginRight: '5px' }} onClick={handleSubmit}>
              Save and Next
            </Button>
            <Button variant="text" color="primary" className="p-button-text" onClick={handleClose}>
              Cancel
            </Button>
          </Grid>
        </Grid>
        {/* </form> */}
      </Box>
    </Paper>
  );
}
